import React, { useEffect } from 'react';
import { Form, Input, notification } from 'antd';
import Cookies from 'js-cookie';
import { useQueryClient } from 'react-query';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import { StyledButton } from '../../components/Button';
import { PageRoutesEnum } from '../../utils/routes';

import { login } from './api/auth';

const StyledLoginFormContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const Login: React.FC = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  useEffect(() => {
    if (Cookies.get('token')) {
      navigate(PageRoutesEnum.main);
    }
  }, [navigate]);

  const onFinish = async (values: { username: string; password: string }) => {
    try {
      const resp = await login(values.username, values.password);
      if (resp.headers?.authorization) {
        Cookies.set('token', resp.headers.authorization);
        navigate(PageRoutesEnum.candidates);
        queryClient.invalidateQueries();
      }
    } catch (error) {
      notification.error({
        message: 'Error',
        description: 'Invalid login data',
      });
    }
  };

  const onFinishFailed = (errorInfo: unknown) => {
    console.log('Failed:', errorInfo);
  };

  return (
    <StyledLoginFormContainer>
      <Form
        name="basic"
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 16 }}
        initialValues={{ remember: true }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
      >
        <Form.Item
          label="Username"
          name="username"
          rules={[{ required: true, message: 'Please input your username!' }]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="Password"
          name="password"
          rules={[{ required: true, message: 'Please input your password!' }]}
        >
          <Input.Password />
        </Form.Item>

        <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
          <StyledButton type="primary" htmlType="submit">
            Submit
          </StyledButton>
        </Form.Item>
      </Form>
    </StyledLoginFormContainer>
  );
};
